import { useState } from 'react';
import { Button } from 'antd';
import { Link } from 'react-router-dom';
import { VscSettings } from 'react-icons/vsc';
import { IoFlashOutline } from 'react-icons/io5';
import { FiPlus } from 'react-icons/fi';
import { Actions } from '../actions';
import { Filters } from '../filters';
import { useTranslation } from 'react-i18next';

const ActionsBar = () => {
  const { t } = useTranslation();
  const [showActions, setShowActions] = useState(false);
  const [showFilters, setShowFilters] = useState(false);

  const handleOpenActions = () => setShowActions(true);
  const handleCloseActions = () => setShowActions(false);
  const handleOpenFilters = () => setShowFilters(true);
  const handleCloseFilters = () => setShowFilters(false);
  return (
    <>
      <div className="action-bar-container">
        <div className="action-bar-left">
          <Button
            size="large"
            icon={<VscSettings />}
            iconPosition="end"
            onClick={handleOpenFilters}
          >
            {t('common.filters')}
          </Button>
        </div>
        <div className="action-bar-right">
          <Button
            size="large"
            icon={<IoFlashOutline />}
            iconPosition="end"
            onClick={handleOpenActions}
          >
            {t('common.actions')}
          </Button>
          <Link to="/regulation/draft" className="add-new-regulation-link">
            <Button size="large" icon={<FiPlus />} type="primary" iconPosition="start">
              {t('common.add-new-regulation')}
            </Button>
          </Link>
        </div>
      </div>
      <Actions open={showActions} onClose={handleCloseActions} />
      <Filters open={showFilters} onClose={handleCloseFilters} />
    </>
  );
};

export default ActionsBar;